import styles from './SearchBar.scss';
import PropTypes from 'prop-types';
import { Component } from 'react';
import lodash from 'lodash';

import { isIE11 } from 'common/util/mobile';

const KEY_CODE_ENTER = 13;

export class SearchBar extends Component {
    constructor() {
        super();
        this.state = {
            query:'',
        };
    }

    clearQuery() {
        this.setState({
            query: ''
        });
    }

    blurAndFocus() {
        // Hack to fix issue with IE11, where Input fields inside draggable div require double click to focus
        if(isIE11()) {
            const queryText = this.refs.queryText;
            queryText.blur();
            queryText.focus();
        }
    }

    handleKeyDown(e){
        const keyCode = e.which;
        if(keyCode === KEY_CODE_ENTER){
            const { query } = this.state;
            this.props.searchFunction(query);
        }
    }

    handleButtonClick() {
        const { query } = this.state;
        this.props.searchFunction(query);
    }

    handleOnChange(e){
        const query = lodash.get(e, 'target.value', '');
        this.setState({
            query,
        });
    }

    render() {
        const {
            query,
        } = this.state;

        return (
            <div className={styles.searchBar} data-cy="SearchBar">
                <SearchIcon />
                <input className={styles.searchBar__inputText}
                    type='search'
                    ref='queryText'
                    placeholder={this.props.placeholder}
                    value={query}
                    onChange={this.handleOnChange.bind(this)}
                    onKeyDown={this.handleKeyDown.bind(this)}
                    onMouseUp={this.blurAndFocus.bind(this)}
                    data-cy="SearchBar-search"
                />
                <SearchControls query={query} handleButtonClick={this.handleButtonClick.bind(this)}/>
            </div>
        );
    }
}

const SearchIcon = () => <i className={styles.searchBar__searchIcon} data-cy="SearchBar-i">search</i>;

const SearchControls = ({query, handleButtonClick}) => {
    if(!query){
        return null;
    }

    return (
        <div className={styles.searchBar__searchControls} data-cy="SearchBar-SearchControls">
            <span className={styles.searchBar__caption}>Use 'Enter', or</span>
            <button className={styles.searchBar__button} onClick={handleButtonClick} data-cy="SearchBar-button">
            Search
            </button>
        </div>
    );

};

SearchBar.propTypes = {
    placeholder: PropTypes.string,

};

export default SearchBar;
